export const colors = {
  dark: {
    primary: '#e74c3c',
    secondary: '#1a1a2e',
    background: '#0f0f1a',
    darkBackground: '#16213e',
    text: '#ecf0f1',
    secondaryText: '#d0d0d0',
    border: '#2a2a3a'
  },
  light: {
    primary: '#3498db',
    secondary: '#2c3e50',
    background: '#ffffff',
    lightBackground: '#ecf0f1',
    accentColor: '#e74c3c',
    text: '#2c3e50',
    border: '#bdc3c7'
  }
}

export const transitions = {
  default: 'all 0.3s ease-in-out',
  slow: 'all 0.5s ease-in-out',
  fast: 'all 0.2s ease-in-out'
}

export const breakpoints = {
  mobile: '768px'
}
